export enum StepBasedOn {

  OperationalFileBeforeFileDate = 0,
  OperationalFileExactFileDate = 1,
  OperationalFileAfterFileDate = 2,

  OtherStep = 3,

  OperationalFileBeforeETD = 4,
  OperationalFileExactETD = 5,
  OperationalFileAfterETD = 6,

  OperationalFileBeforeETA = 7,
  OperationalFileExactETA = 8,
  OperationalFileAfterETA = 9,

  OperationalFileBeforeActualDateOfLoading = 10,
  OperationalFileExactActualDateOfLoading = 11,
  OperationalFileAfterActualDateOfLoading = 12,

  OperationalFileDeforeBerthDate = 13,
  OperationalFileExactBerthDate = 14,
  OperationalFileAfterBerthDate = 15,

  OperationalFileBeforeActualDateOfDeparture = 16,
  OperationalFileExactActualDateOfDeparture = 17,
  OperationalFileAfterActualDateOfDeparture = 18,

  OperationalFileBeforeActualDateOfArrival = 19,
  OperationalFileExactActualDateOfArrival = 20,
  OperationalFileAfterActualDateOfArrival = 21,

  OperationalFileBeforeClosingVesselDate = 22,
  OperationalFileExactClosingVesselDate = 23,
  OperationalFileAfterClosingVesselDate = 24,

  OperationalFileBeforeClosingDocument = 25,
  OperationalFileExactClosingDocument = 26,
  OperationalFileAfterClosingDocument = 27,

  OperationalFileBeforeClosingAMS = 28,
  OperationalFileExactClosingAMS = 29,
  OperationalFileAfterClosingAMS = 30,

  OperationalFileBeforeClosingVGM = 31,
  OperationalFileExactClosingVGM = 32,
  OperationalFileAfterClosingVGM = 33,

  OperationalFileBeforeClosingIMO = 34,
  OperationalFileExactClosingIMO = 35,
  OperationalFileAfterClosingIMO = 36,

  OperationalFileBeforeClosingReefer = 37,
  OperationalFileExactClosingReefer = 38,
  OperationalFileAfterClosingReefer = 39,

  OperationalFileBeforeStorage = 40,
  OperationalFileExactStorage = 41,
  OperationalFileAfterStorage = 42,

  OperationalFileBeforeDetention = 43,
  OperationalFileExactDetention = 44,
  OperationalFileAfterDetention = 45,

  OperationalFileBeforeDemurrage = 46,
  OperationalFileExactDemurrage = 47,
  OperationalFileAfterDemurrage = 48,
}

export enum StepBasedOnSelectboxOptions {
  OperationalFileDate = 0,
  OtherStep = 3,
  ETD = 4,
  ETA = 7,
  ActualDateOfLoading = 10,
  BerthDate = 13,
  ActualDateOfDeparture = 16,
  ActualDateOfArrival = 19,
  ClosingVesselDate = 22,
  ClosingDocument = 25,
  ClosingAMS = 28,
  ClosingVGM = 31,
  ClosingIMO = 34,
  ClosingReefer = 37,
  Storage = 40,
  Detention = 43,
  Demurrage = 46,
}
